<template>
<div class="d-flex flex-column">

    <oauth-pkce-endpoint v-if="hasOauthResponse" @credentials-changed="handleCredentialsChanged" />

    <div v-if="showDebugInfo">
        <v-card v-if="showDebugInfo && credentialInfo">
            <v-card-title>Credential Info</v-card-title>
            <v-card-text>
                <div label="Expires On">{{expiresOn}}</div>
                <div label="Seconds Until Expiry">{{secondsUntilExpiry}}, {{expiryTimeLeftPercentage}}</div>
                <div v-for="(value, key) in credentialInfo" :key="key" :label="key">{{value}}</div>
            </v-card-text>
        </v-card>

        <v-card v-if="showDebugInfo && !credentialInfo">
            <v-card-title>Login Info</v-card-title>
            <v-card-text>

                <div label="code_verifier">{{code_verifier}}</div>
                <div label="code_challenge">{{(code_challenge)}}</div>
                <div label="code_challenge (encoded)">{{simpleUrlEncode(code_challenge)}}</div>

                loginUrl<br />
                <a :href="loginUrl" target="_blank">{{loginUrl}}</a>

            </v-card-text>

            <v-toolbar>
                <v-btn @click="beginLogin">Begin Login</v-btn>
            </v-toolbar>

        </v-card>

    </div>

    <div v-if="allowContent">
        <slot></slot>

        <!-- <v-toolbar>
            <v-btn @click="refreshToken" fab><v-progress-circular size="64" :value="expiryTimeLeftPercentage">{{expiryTimeLeftPercentage}}%</v-progress-circular></v-btn>
            <v-spacer />
            <v-btn @click="logout">Logout</v-btn>
        </v-toolbar> -->
    </div>
</div>
</template>

<script>
//  Resources:
//  https://www.oauth.com/oauth2-servers/pkce/authorization-request/
//  https://blogs.aaddevsup.xyz/2020/08/performing-azure-ad-oauth2-authorization-code-grant-flow-with-pkce-in-postman/
//  Errors
//  https://github.com/MicrosoftDocs/azure-docs/blob/master/articles/active-directory/develop/reference-aadsts-error-codes.md
//  Issue Resolution, Code Challenge Length invalid size
//  https://github.com/MicrosoftDocs/azure-docs/issues/42906
/* eslint-disable */ 
import moment from "moment"
import sha256 from 'crypto-js/sha256'
import base64 from 'crypto-js/enc-base64'
import axios from "axios"

// import handleLogin from "@/mixins/handle-login"
// import settings from "@/config/settings"
// import jwtDecode from "jwt-decode"
// import error from "@/components/templates/error"
// import refreshTokenPanel from "@/components/templates/refresh-token-panel"

const queryString = require('query-string');
import credentials from "@/mixins/credentials-mixin";
import oauthMixin from "./oauth-mixin"
import oauthPkceEndpoint from "./oauth-pkce"
import OauthPkce from './oauth-pkce.vue'
export default {
    mounted() {
        this.begin();
    },
    mixins: [credentials, oauthMixin],
    components: { oauthPkceEndpoint },
    props: {
        authorizeUrl: { type: String, default: "" },
        tokenUrl: { type: String, default: "" },
        logoutUrl: { type: String, default: "" },
        scope: { type: String, default: "" },
        autoLogin: { type: Boolean, default: true },
        client_id: { type: String, default: "" },
        client_secret: { type: String, default: "" },
        redirect_uri: { type: String, default: "" },
        loginIncrementor: { type: Number, default: 0 },
        resource: { type: String, default: "" },
        showDebugInfo: { type: Boolean, default: true },
        refreshTokenWindow: { type: Number, default: 30 },
    },
    data: () => ({
        now: moment(),
        intervalReference: null,
        credentialInfo: null,

    }),
    watch: {
        loginIncrementor(newVal, oldVal) {
            if (newVal > 0) { this.beginLogin(); }
        },
        secondsUntilExpiry(newVal) {
            if (newVal == this.refreshTokenWindow) {
                this.refreshToken();
            }
        },
        expiresOn(newVal) {
            if (!!newVal) {
                this.startTimer();
            } else {
                this.stopTimer();
            }
        },
        globalCredentialCache(newVal) {
            // ;
        },
        credentialInfo() {
            // ;
            this.emitCredentials();
        }
    },
    computed: {
        allowContent() {
            return !!this.credentialInfo;
        },
        expiresOn() {
            return !!this.credentialInfo && !!this.credentialInfo.$expires_on ?
                moment(this.credentialInfo.$expires_on) :
                null;
        },
        expiryPeriod() {
            return !!this.credentialInfo && !!this.credentialInfo.expires_in ?
                this.credentialInfo.expires_in :
                null;
        },
        expiryTimeLeftPercentage() {
            return Math.floor(this.secondsUntilExpiry / this.expiryPeriod * 100)
        },
        secondsUntilExpiry() {
            if (!!this.expiresOn) {
                return this.expiresOn.diff(this.now, 'seconds');
            }
        },
        refreshTokenOptions() {
            if (!this.credentialInfo) { return {} };
            return {
                'client_id': this.client_id,
                'scope': this.scope,
                'refresh_token': this.credentialInfo.refresh_token,
                'grant_type': 'refresh_token',
            };
        },

        // credentialInfo() {
        //     var result = this.getCredentials(this.client_id);
        //     return result;
        // },
        state() {
            return this.generateRandomKey();
        },
        code_verifier() {
            return this.generateRandomKey(43);
        },
        code_challenge() {
            const hash = sha256(this.code_verifier);
            const encoded = base64.stringify(hash);
            const trimmed = encoded.substring(0, encoded.length - 1); // Remove the = delimiter
            return trimmed;
        },
        loginUrl() {
            var result = [this.authorizeUrl,
                `?response_type=code`,
                `&client_id=${this.client_id}`,
                `&scope=${this.scope} offline_access`,
                `&redirect_uri=${this.redirect_uri}`,
                `&state=${this.state}`,
                `&code_challenge_method=S256`,
                `&response_mode=query`,
                `&code_challenge=${this.simpleUrlEncode(this.code_challenge)}`,
            ]
            if (!!this.resource) { result.push(`&resource=${this.resource}`); }

            return result.join("");
        },
    },
    methods: {
        handleCredentialsChanged(credentials) {
            this.credentialInfo = this.getCredentials(this.client_id);
        },
        logout() {
            this.deleteCredentials(this.client_id);
            window.document.location.href = this.logoutUrl;
        },
        emitCredentials() {
            this.$emit("update-credentials", this.credentialInfo);
            this.$emit("logged-in", this.allowContent);
        },
        startTimer() {
            var self = this;
            this.intervalReference = setInterval(() => {
                self.now = moment()
            }, 1000)
        },
        stopTimer() {
            if (!!this.intervalReference) {
                clearTimeout(this.intervalReference);
            }
        },
        async refreshToken() {
            let formData = new FormData();
            Object.keys(this.refreshTokenOptions).forEach(e => {
                formData.append(e, this.refreshTokenOptions[e]);
            });

            var response = await axios({
                method: 'post',
                url: this.tokenUrl,
                data: formData,
            });

            //this.credentialInfo = 
            this.addCredentials(this.client_id, response.data);
        },
        simpleUrlEncode(str) {
            return str
                //.toString('base64')
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=/g, '');
        },
        beginLogin() {
            //set state in localstorage with key
            var state = {
                state: this.state,
                path: this.$route.fullPath,
                client_id: this.client_id,
                token_uri: this.tokenUrl,
                code_verifier: this.code_verifier,
                client_secret: null,
                type: 'pkce',
                scope: this.scope,
                redirect_uri: this.redirect_uri,
            };

            window.localStorage.setItem(this.state, JSON.stringify(state));
            window.document.location.href = this.loginUrl;
        },
        generateRandomKey(length = 32) {
            var result = [];
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
            }
            return result.join("");
        },
        begin() {
            if (!this.hasOauthResponse) {
                this.credentialInfo = this.getCredentials(this.client_id);
                if (!this.credentialInfo && this.autoLogin && !this.hasOauthResponse) {
                    this.beginLogin();
                }
            }
            // if(!!this.expiresOn)
            // {
            //     this.startTimer();
            // }

        },
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ./src/components/auth/oauth-wrapper-pkce.vue